//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/NXObjectList.js";
import "../no/SelectNXObject.js";
import "../no/SelectNXObjectList.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"Accuracy",1,0],[1,"AuxiliaryFaces",0,"ScCollector",0],[0,"ConstraintOptions",1,0],[1,"CutCurves",0,"Section",0],[0,"DestinationCoordinateSystem",1,"CoordinateSystem",0],[0,"DistortionMapOptions",1,0],[1,"FixedElementsList",0,"NXObjectList",0],[1,"FlatteningFeature",0,"SelectNXObject",0],[1,"OuterBoundary",0,"SelectNXObject",0],[1,"PreservedCurves",0,"Section",0],[0,"ReverseTransformation",1,0],[0,"SourceDirection",1,"Direction",0],[1,"SourceFaces",0,"ScCollector",0],[0,"SourceOrigin",1,"Point",0],[0,"SourceVDirection",1,"Direction",0],[0,"TabDetection",1,0],[1,"TransformationObjects",0,"SelectNXObjectList",0],[0,"Type",1,0]],[],[]];
SPLM.Features.FlatteningAndFormingBuilderEx = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.FlatteningAndFormingBuilderEx";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.FlatteningAndFormingBuilderEx.Types = Object.freeze({
    "Calculation" : "Calculation", "Reuse" : "Reuse"});

SPLM.Features.FlatteningAndFormingBuilderEx.DistortionMap = Object.freeze({
    "None" : "None", "Length" : "Length", "Area" : "Area", "Angle" : "Angle"});

SPLM.Features.FlatteningAndFormingBuilderEx.Constraints = Object.freeze({
    "NoConstraints" : "NoConstraints", "FixedElements" : "FixedElements", "FixedArcLength" : "FixedArcLength"});

SPLM.Features.FlatteningAndFormingBuilderEx.AccuracyOptions = Object.freeze({
    "Coarse" : "Coarse", "Standard" : "Standard", "Fine" : "Fine", "ExtraFine" : "ExtraFine"});

export default SPLM;